import React, { useState } from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Checkbox from 'components/Checkbox';
import Radio from 'components/Radio';
import { Content } from './styles';

const NotificationPreferences = ({ scan={} }) => {

  const [customerPreferences, setCustomerPreferences] = useState(scan.customerPreferences || {});

  return (
    <Card>
      <CardHeader>
        <div className='type'>NOTIFICATION PREFERENCES</div>
      </CardHeader>
      <Content>
        <div className='title first'>WHEN SHOULD YOU BE NOTIFIED?</div>
        <div className='optionGroup'>
          <Radio 
            label="Always"
            name="choice"
            value="always" 
            checked={customerPreferences.notification === 'always'}
            onChange={(value) => {
              setCustomerPreferences((prev) => ({
              ...prev,
              notification: value
            }))}} 
          />
          <Radio 
            label="Only when I’m signed in"
            name="choice"
            value="signedIn" 
            checked={customerPreferences.notification === 'signedIn'}
            onChange={(value) => setCustomerPreferences((prev) => ({
              ...prev,
              notification: value
            }))} 
          />
        </div>
        <div className='title'>CHOOSE WHICH ALERT TYPES YOU WANT TO BE NOTIFIED ABOUT.</div>
        <div className='optionGroup'>
          <Checkbox
            checked={customerPreferences.criticalAlerts}
            onChange={() => {
              setCustomerPreferences((prev) => ({
                ...prev,
                criticalAlerts: !prev.criticalAlerts
              }))
            }}
            title={"Critical alerts"}
          />
          <Checkbox
            checked={customerPreferences.highPriorityAlerts}
            onChange={() => {
              setCustomerPreferences((prev) => ({
                ...prev,
                highPriorityAlerts: !prev.highPriorityAlerts
              }))
            }}
            title={"High-priority alerts"}
          />
          <Checkbox
            checked={customerPreferences.mediumPriorityAlerts}
            onChange={() => {
              setCustomerPreferences((prev) => ({
                ...prev,
                mediumPriorityAlerts: !prev.mediumPriorityAlerts
              }))
            }}
            title={"Medium-priority alerts"}
          />
          <Checkbox
            checked={customerPreferences.lowPriorityAlerts}
            onChange={() => {
              setCustomerPreferences((prev) => ({
                ...prev,
                lowPriorityAlerts: !prev.lowPriorityAlerts
              }))
            }}
            title={"Low-priority alerts"}
          />
        </div>
        <div className='title'>HOW SHOULD YOU BE NOTIFIED?</div>
        <div className='optionGroup'>
          <Checkbox
            checked={customerPreferences.pushNotifications}
            onChange={() => {
              setCustomerPreferences((prev) => ({
                ...prev,
                pushNotifications: !prev.pushNotifications
              }))
            }}
            title={"Push notifications"}
          />
          <Checkbox
            checked={customerPreferences.emailNotifications}
            onChange={() => {
              setCustomerPreferences((prev) => ({
                ...prev,
                emailNotifications: !prev.emailNotifications
              }))
            }}
            title={"Email notifications"}
          />
          <Checkbox
            checked={customerPreferences.smsNotifications}
            onChange={() => {
              setCustomerPreferences((prev) => ({
                ...prev,
                smsNotifications: !prev.smsNotifications
              }))
            }}
            title={"SMS notifications"}
          />
        </div>
      </Content>
    </Card>
  )
}

export default NotificationPreferences;
